<template>
  <div
    v-if="items && items.length"
    class="map-route-legend"
  >
    <div
      v-for="(item, index) in items"
      :key="'legend-' + index + '-' + item.label"
      class="map-route-legend-item"
    >
      <span
        class="map-route-legend-swatch"
        :style="{
          backgroundColor: item.color,
          height: Math.max(item.lineWidth, 3) + 'px',
        }"
      />
      <span class="map-route-legend-label">{{ item.label }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MapRouteLegend',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.map-route-legend {
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 10;
  display: flex;
  flex-wrap: wrap;
  gap: 8px 12px;
  max-width: calc(100% - 16px);
  padding: 6px 10px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);
  font-size: 12px;
  line-height: 1.2;
}

.map-route-legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.map-route-legend-swatch {
  display: inline-block;
  min-width: 36px;
  border-radius: 2px;
  flex-shrink: 0;
}

.map-route-legend-label {
  white-space: nowrap;
}
</style>
